import { Form } from "antd";
import TextArea from "antd/lib/input/TextArea";
import GCReviewersDropdown from "components/gc-reveiewer-dropdown";
import ResponsibleDesignFirmsDropdown from "components/responsible-design-firms";
import DependedCompanyUserDropdownComponent from "components/responsible-designers";
import {
  CompanyParticipationType,
  UserParticipationType
} from "constants/index";
import { ProjectContext } from "context/ProjectProvider";
import { TFetureDetailUpdateAction } from "entity-app/models";
import { useContext, useEffect } from "react";

export default function DesignPackageGeneralInfo(props: {
  featureInstanceData: any;
  actions: TFetureDetailUpdateAction;
  disabled: boolean;
}) {
  const { featureInstanceData, actions, disabled } = props;
  const [form] = Form.useForm();
  const selectedDesignFirmId = Form.useWatch("design_firm", form);

  const {
    columnHeaders: { designPackageHeaderMap }
  } = useContext(ProjectContext);

  useEffect(() => {
    const designFirm = featureInstanceData?.feature_company_participants?.length
      ? featureInstanceData?.feature_company_participants[0]?.vendor_id
      : "";

    const responsibleDesigner =
      featureInstanceData?.feature_user_paticipants?.find(
        (user: any) =>
          user?.user_participation_type?.id ===
          UserParticipationType.RESPONSIBLE_DESIGNER
      );

    const responsibleDesignerId = responsibleDesigner?.user_unregistered
      ? responsibleDesigner.user_unregistered
      : responsibleDesigner?.user?.id;

    const gcRepresentative =
      featureInstanceData?.feature_user_paticipants?.find(
        (participant: any) =>
          participant.user_participation_type_id ===
          UserParticipationType.GC_REPRESENTATIVE
      );

    form.setFieldsValue({
      description: featureInstanceData?.description,
      design_firm: designFirm,
      responsible_designer: responsibleDesignerId,
      gc_representative: gcRepresentative?.user?.id
    });
  }, [featureInstanceData, form]);

  return (
    <Form layout="vertical" form={form}>
      <Form.Item name="description" label={designPackageHeaderMap?.description}>
        <TextArea
          disabled={disabled}
          rows={5}
          placeholder="Enter Description"
          onBlur={async (event: any) => {
            const oldValue = featureInstanceData?.description;
            if (oldValue === event?.target?.value?.trim()) return;
            await actions.updateFeatureInstanceFields({
              description: event.target.value?.trim()
            });
          }}
        />
      </Form.Item>
      <Form.Item
        label={designPackageHeaderMap?.responsible_designer_id}
        name="design_firm"
      >
        <ResponsibleDesignFirmsDropdown
          disabled={disabled}
          onChange={async (value: any) => {
            form.setFieldValue("responsible_designer", "");
            await actions.updateFeatureCompanyParticipantWithEmptyUsers({
              vendorIds: [value],
              companyParticipantTypeId:
                CompanyParticipationType.DESIGN_FIRM_CONTRACTOR,
              userParticipationTypeId:
                UserParticipationType.RESPONSIBLE_DESIGNER
            });
          }}
        />
      </Form.Item>
      <Form.Item
        label={designPackageHeaderMap?.design_firm_id}
        name="responsible_designer"
      >
        <DependedCompanyUserDropdownComponent
          projectParticipantType="designReviewers"
          disabled={disabled}
          onChange={async (value: any) => {
            await actions.updateFeatureUserParticipant({
              user_id: value,
              user_participation_type_id:
                UserParticipationType.RESPONSIBLE_DESIGNER
            });
          }}
          selectedCompanyFieldId={selectedDesignFirmId}
        />
      </Form.Item>
      <Form.Item
        label={designPackageHeaderMap?.gc_representative_id}
        name="gc_representative"
      >
        <GCReviewersDropdown
          disabled={disabled}
          onChange={async (value: any) => {
            await actions.updateFeatureUserParticipant({
              user_id: value,
              user_participation_type_id:
                UserParticipationType.GC_REPRESENTATIVE
            });
          }}
        />
      </Form.Item>
    </Form>
  );
}
